module.exports = __webpack_public_path__ + "static/media/other-assignments-splash.bfd725c3.svg";